import { Box, Grid } from '@material-ui/core';
import { LoanDrawsDashboard } from '@roc/feature-draws';
import { LoanSummaryDecisionTab } from '@roc/feature-loan-summary';
import { useLoanStore } from '@roc/feature-loans';
import { observer } from 'mobx-react';

export const DecisionCommentsTab = observer(() => {
  return <LoanSummaryDecisionTab md={12} />;
});
